// Load polyfills first, before any other imports
import './polyfills';

import { Toaster } from '@/components/ui/toaster.tsx';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';

import * as Sentry from '@sentry/react';
import { getEnvironmentLevel } from './lib/common-utils.ts';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    environment: getEnvironmentLevel(),
    tracesSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById('app')!).render(
  <React.StrictMode>
    <>
      <App />
      <Toaster />
    </>
  </React.StrictMode>,
);
